import request from '@/utils/request'

/**
 * @description 患者管理一期重构接口（20220621）
 * 1. 线下处方列表
 * 2. 线下处方详情
 */
// 线下处方列表（新）
export function offLinePrescriptionList(data) {
  return request({
    url: '/health-recommend/recommend/prescription/offline/list',
    method: 'get',
    params: data
  })
}
// 线下处方详情（新）
export function OffLinePre_BySerialNumberOrId(data) {
  return request({
    url: '/health-recommend/recommend/prescription/offline/detail',
    method: 'get',
    params: data
  })
}
// 线下处方详情接口 通过编号查询 POD(prescriptionOfflineDetail) （已弃用）
// export function OffLinePre_BySerialNumber(serialNumber) {
//   return request({
//     headers: {
//       _p: 3
//     },
//     url: '/health-recommend/pres-offline/detail/serial',
//     params: {
//       serialNumber
//     }
//   })
// }
// 线上处方列表
export function prescription(userId, page, size, type) {
  return request({
    url: '/health-recommend/doctor-assistant/prescription/list',
    params: {
      userId: userId,
      page: page,
      num: size,
      queryType: type
    }
  })
}
// REF:线上处方详情,通过编号查询 PD=>prescriptionDetail
export function PD_bySerialNumber(serialNumber) {
  return request({
    url: '/health-recommend/doctor-assistant/prescription/note/detail',
    params: {
      serialNumber
    }
  })
}
// 线上处方详情 通过id查询
export function PD_byId(id) {
  return request({
    url: '/health-recommend/doctor-assistant/prescription/detail',
    params: {
      prescriptionId: id
    }
  })
}

// 健康辅助方列表
export function health(userId, page, size, type) {
  return request({
    url: '/health-recommend/doctor-assistant/health/list',
    params: {
      userId: userId,
      page: page,
      num: size,
      isBought: type
    }
  })
}
// 联合处方列表
export function prescriptionGroupList(userId, page, size) {
  return request({
    url: '/health-recommend/doctor-assistant/unite/prescription/list',
    params: {
      userId: userId,
      page: page,
      num: size
    }
  })
}
// 联合处方列表
export function prescriptionList(data) {
  return request({
    url: '/health-recommend/recommend/prescription/assistant/patient-prescription-list',
    method: 'post',
    data: data
  })
}
// REF:健康辅助方详情 通过编号查询 HD=>healthDetail
export function HD_bySerialNumber(serialNumber) {
  return request({
    url: '/health-recommend/doctor-assistant/health/note/detail',
    params: {
      serialNumber
    }
  })
}
// 健康辅助方详情
export function HD_byId(id) {
  return request({
    url: '/health-recommend/doctor-assistant/health/detail',
    params: {
      prescriptionId: id
    }
  })
}
// 联合处方详情 （就诊记录-线上问诊详情）
export function uniteDetail(id) {
  return request({
    url: '/health-recommend/prescription/main/unite/detail',
    params: {
      prescriptionSn: id
    }
  })
}

// 线下处方列表 (已弃用)
export function prescriptionOffline(userId, page, size) {
  return request({
    headers: {
      _p: 3
    },
    url: '/health-recommend/pres-offline/list/da',
    method: 'post',
    data: {
      ucDoctorId: userId,
      pageNo: page,
      pageSize: size
    }
  })
}

// 线下处方活动修改
export function changePresOffline(presOfflineId, activityTemplateId) {
  return request({
    headers: {
      _p: 3
    },
    url: '/health-recommend/pres-offline/modify',
    method: 'post',
    params: {
      presOfflineId,
      activityTemplateId
    }
  })
}
// 处方疗效判定
export function prescriAssertCure(data) {
  return request({
    url: '/health-recommend/recommend/prescription/effectiveness/determineOrUpdateEffectiveness',
    method: 'post',
    data
  })
}

// 通过处方编号查询最终会同时判定的所有处方编号
export function getDetermineSerialNumbers(data) {
  return request({
    url: '/health-recommend/recommend/prescription/effectiveness/getDetermineSerialNumbers',
    method: 'get',
    params: data
  })
}
// 根据随访ID判定其关联的所有处方
export function determineEffectByfollID(data) {
  return request({
    url: '/health-recommend/recommend/prescription/effectiveness/determineEffectivenessByFollowupId',
    method: 'post',
    data
  })
}
// 通过随访计划ID查询最终会同时判定的所有处方编号
export function getSerialListByfollID(data) {
  return request({
    url: '/health-recommend/recommend/prescription/effectiveness/getDetermineSerialNumbersByFollowupId',
    method: 'get',
    params: data
  })
}
